import {
  message,
  PageHeader,
  Spin,
  Select,
  //Form as FormInitial,
  Row,
  Col,
  Input,
  Upload,
  Space,
  Switch,
  Tooltip,
  Typography,
  AutoComplete,
  Button
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  cuentaMask,
  InputItem,
  ButtonItem,
  SwitchItem,
  ErrorItem,
  SelectInsumosItem,
  DatePickerItem,
  DynamicCardForm,
  TabbedDynamicTable
} from "../../../../Components/Items";
import { PlusOutlined, FileExcelOutlined, UploadOutlined, ContainerOutlined, CommentOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import AgregarCuentaContable from "../../CuentasContables/AgregarCuentaContable/AgregarCuentaContable";
import AgregarMarbetes from "../../Marbetes/AgregarMarbetes/AgregarMarbetes";
import * as XLSX from 'xlsx'
import AgregarLotes from "../../LotesCaducidades/AgregarLotes/AgregarLotes";
import SelectUbicacionesProyectoItem from "../../../../Components/SelectUbicacionesProyectoItem";
import moment from "moment";

const { Option } = Select;

class AgregarInventario extends Component {
  formRef = React.createRef();
  searchRef = React.createRef();
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    todasInsumos: [],
    todasUbicaciones: [],
    ubicacionesProyectoId: undefined,
    objetoInsumos: null,
    todasCuentaContable: null,
    objetoCuentaContable: null,
    modalAgregarCuentaContable: false,
    modalAgregarMarbetes: false,
    modalAgregarMarbetesIndex: null,
    modalAgregarMarbetesMarbetes: null,
    archivosExcel: [],
    capturaModoRapido: false,
    busquedaRapida: '',
    sugerenciasSearch: [],
  };
  componentDidMount() {
    this.consultarTodo();
    this._ctrlBHandler = (e) => {
      if (e.ctrlKey && e.key === 'b') {
        e.preventDefault();
        this.searchRef.current?.focus();
      }
    };
    document.addEventListener('keydown', this._ctrlBHandler);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this._ctrlBHandler);
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "cuentascontables/selectCuentasContablesFinales",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasCuentaContable: res.data });
          this.setState({
            objetoCuentaContable: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + ' - ' + value.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }

  //Trae UNA sola vez todas las ubicaciones activas del almacén elegido y las deja en cache (this.state.todasUbicaciones)
  //para que cada renglón de insumos use SelectUbicacionesProyectoItem en modo "opciones" (sin volver a consultar por renglón).
  cargarUbicacionesDelAlmacen = async (proyectoId, forzar = false) => {
    if (!this.props.moduloWms || !proyectoId) {
      this.setState({ todasUbicaciones: [], ubicacionesProyectoId: undefined });
      return [];
    }
    if (!forzar && this.state.ubicacionesProyectoId === proyectoId) {
      return this.state.todasUbicaciones;
    }
    try {
      const res = await axios.post(
        "ubicacionProyecto/selectUbicacionesProyecto",
        { empresaId: this.props.empresaId, proyectoId, estado: 1 },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        const ubicaciones = res.data.ubicaciones || [];
        this.setState({ todasUbicaciones: ubicaciones, ubicacionesProyectoId: proyectoId });
        return ubicaciones;
      }
    } catch (err) {
      console.error(err);
    }
    return [];
  };
  onFinishFailed(e) {
    ErrorItem(e)
  }
  onFinish(values) {
    if (!values.insumos || values.insumos?.length === 0)
      return message.error("Agregue insumos para agregar inventario");
    this.setState({ loading: true });
    axios
      .post(
        "agregarInventario/agregarOrdenAgregarInventario",
        {
          ...values,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se ha registrado la orden"
          );
          this.formRef.current.resetFields();
          this.atras();
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "No se puede registrar la orden");
        } else {
          message.error("Hubo un error y la orden no se registro");
        }
      });
  }
  abrirAgregarCuentaContable() {
    this.setState({ modalAgregarCuentaContable: true });
  }
  cerrarAgregarCuentaContable(codigo) {
    this.setState({ modalAgregarCuentaContable: false });
    this.consultarTodo()
  }

  async onChangeInsumo(value, index, insumoEncontrado) {
    if (this.formRef.current.getFieldValue('contabilizar')) {
      this.setState({ loading: true });
      let arrayValue = await this.formRef.current.getFieldValue("insumos");
      const insumoId = arrayValue[index].insumoId;
      let insumo
      if (insumoEncontrado) {
        insumo = insumoEncontrado;
        const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
        if (!yaExiste) {
          await this.setState(prev => ({
            todasInsumos: [...prev.todasInsumos, insumo]
          }));
        }
      } else {
        insumo = this.state.todasInsumos.find(
          (valueInsumos) => valueInsumos._id === insumoId
        );
      }
      this.setState({ loading: false });
      if (!insumo) return;

      arrayValue[index].costo = insumo.costo

      this.formRef.current.setFieldsValue({ insumos: arrayValue })
    } else {
      this.setState({ loading: true });
      let arrayValue = await this.formRef.current.getFieldValue("insumos");
      const insumoId = arrayValue[index].insumoId;
      let insumo
      if (insumoEncontrado) {
        insumo = insumoEncontrado;
        const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
        if (!yaExiste) {
          await this.setState(prev => ({
            todasInsumos: [...prev.todasInsumos, insumo]
          }));
        }
      } else {
        insumo = this.state.todasInsumos.find(
          (valueInsumos) => valueInsumos._id === insumoId
        );
      }
      this.setState({ loading: false });
    }
  }

  abrirAgregarMarbetes(value, marbetes) {
    this.setState({
      modalAgregarMarbetes: true,
      modalAgregarMarbetesIndex: value,
      modalAgregarMarbetesMarbetes: marbetes
    })
  }

  cerrarAgregarMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalAgregarMarbetesIndex].marbetes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalAgregarMarbetes: false,
      modalAgregarMarbetesIndex: null,
      modalAgregarMarbetesMarbetes: null
    })
  }

  async descargarExcel() {
    this.setState({ loading: true });
    const response = await fetch('/plantillaAgregarInventario.xlsx'); // asegúrate de que esté en la carpeta "public"
    const data = await response.arrayBuffer(); // lo convertimos en un arrayBuffer

    let plantillaXlsx = XLSX.read(data, { type: "array" });


    // Guardar el archivo modificado
    XLSX.writeFile(plantillaXlsx, "plantillaAgregarInventario.xlsx");
    this.setState({ loading: false });

  }

  async descargarExcelCI() {
    this.setState({ loading: true });
    const response = await fetch('/plantillaAgregarInventario.xlsx'); // asegúrate de que esté en la carpeta "public"
    const data = await response.arrayBuffer(); // lo convertimos en un arrayBuffer

    let plantillaXlsx = XLSX.read(data, { type: "array" });

    let hojaInsumos

    try {
      const responseInsumos = await axios.post(
        "insumos/selectInsumosInventariablesRaw",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )


      if (responseInsumos.data.success === 2) {
        // Crear una nueva hoja con dato
        hojaInsumos = responseInsumos.data.insumos.map((insumo) => {
          return {
            "Clave": insumo.clave,
            "Descripcion": insumo.descripcion,
          }
        })
        this.setState({ todasInsumos: responseInsumos.data.insumos });
      }

    } catch (err) {
      console.error(err);
    }

    if (hojaInsumos) {
      const nuevaHojaInsumos = XLSX.utils.json_to_sheet(hojaInsumos);

      // Agregar la nueva hoja al workbook
      XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaInsumos, "Insumos");
    }

    const proyectoId = this.formRef.current?.getFieldValue('proyectoId');
    if (this.props.moduloWms) {
      //La columna va siempre que la empresa tenga WMS, aunque todavia no hayan elegido el almacen:
      //el almacen se valida al momento de importar, no al descargar la plantilla.
      const ubicacionesAlmacen = proyectoId
        ? await this.cargarUbicacionesDelAlmacen(proyectoId)
        : [];

      // Insertar columna "Ubicacion" después de "Cantidad"
      const nombrePrimeraHojaCI = plantillaXlsx.SheetNames[0];
      const hojaCI = plantillaXlsx.Sheets[nombrePrimeraHojaCI];
      const filasCI = XLSX.utils.sheet_to_json(hojaCI, { header: 1, defval: "" });
      const encabezadosCI = filasCI[0] || [];
      if (!encabezadosCI.includes("Ubicacion")) {
        const indiceCantidad = encabezadosCI.indexOf("Cantidad");
        const posicion = indiceCantidad === -1 ? encabezadosCI.length : indiceCantidad + 1;
        const filasConUbicacion = filasCI.map((fila, index) => {
          const nuevaFila = [...fila];
          while (nuevaFila.length < encabezadosCI.length) nuevaFila.push("");
          nuevaFila.splice(posicion, 0, index === 0 ? "Ubicacion" : "");
          return nuevaFila;
        });
        plantillaXlsx.Sheets[nombrePrimeraHojaCI] = XLSX.utils.aoa_to_sheet(filasConUbicacion);
      }

      const hojaUbicaciones = ubicacionesAlmacen.map((ubicacion) => ({
        "Ubicación": ubicacion.nombre,
        "Clave": ubicacion.clave,
      }));
      const avisoSinUbicaciones = proyectoId
        ? "(sin ubicaciones registradas en este almacén)"
        : "(seleccione el proyecto/almacén de la orden y vuelva a descargar la plantilla para ver las ubicaciones válidas)";
      const nuevaHojaUbicaciones = XLSX.utils.json_to_sheet(
        hojaUbicaciones.length > 0 ? hojaUbicaciones : [{ "Ubicación": avisoSinUbicaciones }]
      );
      XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaUbicaciones, "Ubicaciones");
    }

    //Documentar en la hoja "Detalles" las columnas opcionales que la plantilla base no describe
    const nombreHojaDetalles = plantillaXlsx.SheetNames.find((nombre) => nombre === "Detalles");
    if (nombreHojaDetalles) {
      const filasDetalles = XLSX.utils
        .sheet_to_json(plantillaXlsx.Sheets[nombreHojaDetalles], { header: 1, defval: "" })
        .filter((fila) => fila.some((celda) => `${celda}`.trim() !== ""));
      const yaDocumentadas = filasDetalles.map((fila) => `${fila[0]}`.trim().toLowerCase());
      const detallesFaltantes = [
        ["Lote", "NO", "Alfanumerico (Acepta Numero y Letras)"],
        ["Caducidad", "NO", "Fecha (la celda debe tener formato de fecha, no texto)"],
        ...(this.props.moduloWms
          ? [[
            "Ubicacion",
            "NO",
            "Debe ser el nombre de una ubicacion activa del almacen de la orden (ver hoja Ubicaciones)",
          ]]
          : []),
      ].filter((fila) => !yaDocumentadas.includes(fila[0].toLowerCase()));
      if (detallesFaltantes.length > 0) {
        plantillaXlsx.Sheets[nombreHojaDetalles] = XLSX.utils.aoa_to_sheet([
          ...filasDetalles,
          ...detallesFaltantes,
        ]);
      }
    }

    // Guardar el archivo modificado
    XLSX.writeFile(plantillaXlsx, "plantillaAgregarInventario.xlsx");

    this.setState({ loading: false });

  }

  async onChangeArchivo(e) {
    this.setState({ loading: true })
    await this.formRef.current.validateFields().then(() => {
      if (e.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.setState({ archivosExcel: [{ ...e.file, name: e.file.name, status: 'uploading', response: 'Cargando', }], arhcivo: e.file });
        this.cargarArchivoExcel(e.file)
      } else {
        message.error('El archivo debe ser un archivo de excel')
        this.setState({ loading: false })
      }
    }).catch((error) => {
      message.error('Complete los campos requeridos antes de cargar el archivo')
      this.setState({ loading: false })
    })
  }

  cargarArchivoExcel(file) {
    let hojas = [];
    let reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onloadend = (e) => {
      let data = new Uint8Array(e.target.result)
      let workbook = XLSX.read(data, { type: 'array' })

      workbook.SheetNames.forEach((sheetName) => {
        let Xl_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
        hojas.push({
          data: Xl_row_object,
          sheetName
        })
      })
      let hoja1 = hojas[0].data
      this.archivoVerificar(hoja1).then((dataReturn) => {
        if (dataReturn.errores === 0) {
          this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success' }] });
          this.formRef.current.setFieldsValue({
            insumos: dataReturn.objeto,
          })
        } else {
          this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success', response: 'Con errores', }], archivoError: dataReturn.archivoErrores });
          this.formRef.current.setFieldsValue({
            insumos: dataReturn.objeto,
          })
          message.error('Se han detectado ' + dataReturn.errores + ' errores')
          message.info('Se se importan solo se importaran los campos correctos: ' + Number(hoja1.length - dataReturn.filaErrores))
        }
        this.setState({ loading: false })
      })
    }
  }

  async archivoVerificar(data) {
    let errores = 0
    let filaErrores = 0
    let mensaje = []
    const archivoEditar = XLSX.utils.book_new()
    const arrayErrores = []
    let objeto = []

    if (this.state.todasInsumos.length === 0) {
      try {
        const responseInsumos = await axios.post(
          "insumos/selectInsumosInventariablesRaw",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )


        if (responseInsumos.data.success === 2) {
          // Crear una nueva hoja con datos
          await this.setState({ todasInsumos: responseInsumos.data.insumos });
        }

      } catch (err) {
        console.error(err);
      }
    }

    const proyectoIdOrden = this.formRef.current?.getFieldValue('proyectoId');
    if (this.props.moduloWms && proyectoIdOrden) {
      await this.cargarUbicacionesDelAlmacen(proyectoIdOrden);
    }

    await Promise.all(data.map(async (data, index) => {
      let mensajeErrores = null
      let erroresFila = 0
      let fila = data['__rowNum__'] + 1
      let clave = data['Clave'] ? `${data['Clave']}`.trim() : undefined
      let descripcion = data['Descripcion'] ? `${data['Descripcion']}`.trim() : undefined
      let costo = data['Costo']
      let cantidad = data['Cantidad'] ? `${data['Cantidad']}`.trim() : undefined
      let lote = data['Lote'] ? `${data['Lote']}`.trim() : undefined
      let caducidad = data['Caducidad'] ? `${data['Caducidad']}`.trim() : undefined
      let ubicacionNombre = data['Ubicacion'] ? `${data['Ubicacion']}`.trim() : undefined
      const checarQueSeaNumero = (valor, nombreCampo) => {
        if (valor !== '' && valor !== undefined) {
          if (isNaN(valor) === true) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${nombreCampo} fila: ${fila} no es un numero`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un numero` : `${nombreCampo} no es un numero`
          }
        }
      }
      const queEste = (valor, nombreCampo) => {
        if (valor === '' || valor === undefined) {
          errores += 1
          erroresFila += 1
          mensaje.push(`${nombreCampo} fila: ${fila} esta vacio`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} esta vacio` : `${nombreCampo} esta vacio`
        }
      }
      const queSeaStringValido = (valor, nombreCampo) => {
        const patron = /^[\p{L}\p{N}\p{P}\p{S}\s]*$/u
        if (valor !== '' && valor !== undefined) {
          if (!patron.test(valor)) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${nombreCampo} fila: ${fila} no es un valor acceptado`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un valor acceptado` : `${nombreCampo} no es un valor acceptado`
          }
        }
      }
      const queSeaFechaValida = (valor, nombreCampo) => {
        if (valor !== '' && valor !== undefined) {
          if (isNaN(valor) === true) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${nombreCampo} fila: ${fila} no es una fecha valida`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es una fecha valida` : `${nombreCampo} no es una fecha valida`
          }
        }
      }
      queEste(clave, 'Clave')
      queEste(descripcion, 'Descripción')
      queEste(costo, 'Costo')
      queEste(cantidad, 'Cantidad')
      queSeaStringValido(clave, 'Clave')
      queSeaStringValido(descripcion, 'Descripción')
      queSeaStringValido(lote, 'Lote')
      queSeaStringValido(caducidad, 'Caducidad')
      queSeaFechaValida(caducidad, 'Caducidad')
      checarQueSeaNumero(costo, 'Costo')
      checarQueSeaNumero(cantidad, 'Cantidad')

      let insumoId

      // const encontrarInsumo = this.state.todasInsumos.find((value) => value.clave === clave && value.descripcion === descripcion)
      const encontrarInsumo = this.state.todasInsumos.find((value) => value.clave === clave || value.codigoBarras === clave)
      if (!encontrarInsumo) {
        errores += 1
        erroresFila += 1
        mensaje.push(`Insumo fila: ${fila} no existe`)
        mensajeErrores = mensajeErrores ? mensajeErrores + `, Insumo no existe` : `Insumo no existe`
      } else {
        insumoId = encontrarInsumo._id
      }

      let ubicacionId
      if (this.props.moduloWms && ubicacionNombre) {
        const encontrarUbicacion = this.state.todasUbicaciones.find(
          (u) => u.nombre.trim().toLowerCase() === ubicacionNombre.toLowerCase()
        )
        if (!encontrarUbicacion) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Ubicacion fila: ${fila} no es una ubicación válida de ese almacén`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Ubicacion no es válida` : `Ubicacion no es válida`
        } else {
          ubicacionId = encontrarUbicacion._id
        }
      }

      if (erroresFila === 0) {
        objeto.push({
          costo: costo,
          cantidad: cantidad,
          ...(lote ? { lote: lote } : {}),
          ...(caducidad ? {
            caducidad: moment('1899-12-30')
              .add(Number(caducidad), 'days')
          } : {}),
          insumoId: insumoId,
          ...(ubicacionId ? { ubicacionId } : {}),
        })
      } else {
        arrayErrores.push({
          'Errores': mensajeErrores,
          'Fila archivo inicial': fila,
          ...data,
        })
        filaErrores += 1
      }
      return null
    }))
    const hoja = XLSX.utils.json_to_sheet(arrayErrores)
    XLSX.utils.book_append_sheet(archivoEditar, hoja, 'Hoja Errores')
    return { objeto: objeto, errores: errores, filaErrores, mensaje: mensaje, archivoErrores: archivoEditar }
  }

  descargarArchivoErrores() {
    let wbout = XLSX.write(this.state.archivoError, { bookType: 'xlsx', type: 'binary' });
    const s2ab = (s) => {
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf);  //create uint8array as viewer
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
      return buf;
    }
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" })
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'errores.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  abrirAgregarLotes(value, lotes, insumoId, tipoEspecie, vehiculo) {
    this.setState({
      modalAgregarLotes: true,
      modalAgregarLotesIndex: value,
      modalAgregarLotesLotes: lotes,
      modalAgregarLotesInsumoId: insumoId,
      modalAgregarLotesFechaIngresoM: this.props.taxidermia ? this.formRef.current.getFieldValue('fechaOrden') : undefined,
      modalAgregarLotesTipoEspecie: tipoEspecie ? tipoEspecie : '',
      modalAgregarLotesVehiculo: vehiculo,
    })
  }

  cerrarAgregarLotes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalAgregarLotesIndex].lotes = value
    if (this.props.taxidermia && value[0]?.numero) {
      insumos[this.state.modalAgregarLotesIndex].codigo = value[0].numero
    }
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalAgregarLotes: false,
      modalAgregarLotesIndex: null,
      modalAgregarLotesLotes: null,
      modalAgregarLotesInsumoId: null,
      modalAgregarLotesFechaIngresoM: null,
      modalAgregarLotesTipoEspecie: null
    })
  }
  
    datosBaseListos = () => {
    const proyectoId = this.formRef.current?.getFieldValue('proyectoId');
    const contabilizar = this.formRef.current?.getFieldValue('contabilizar');
    const cuentaAbonoId = this.formRef.current?.getFieldValue('cuentaAbonoId');
    if (!proyectoId) return false;
    if (contabilizar && !cuentaAbonoId) return false;
    return true;
  };

  buscarInsumoRapido = async (valor) => {
    if (!valor || !valor.trim()) return;
    if (!this.datosBaseListos()) {
      message.info('Agregue los datos primero (proyecto y cuenta abono)');
      return;
    }
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "insumos/selectInsumosItemInventariableFuncion",
        { empresaId: this.props.empresaId, query: valor.trim(), skip: 0 },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2 && res.data.insumos?.length > 0) {
        const exacto = res.data.insumos.find(
          (i) =>
            i.clave?.toString().toLowerCase() === valor.trim().toLowerCase() ||
            i.codigoBarras?.toString().toLowerCase() === valor.trim().toLowerCase()
        );
        const insumo = exacto || res.data.insumos[0];
        await this.agregarInsumoRapido(insumo);
      } else {
        message.warning('No se encontró un insumo con: ' + valor);
      }
    } catch (e) {
      message.error('Error al buscar insumo');
    } finally {
      this.setState({ loading: false, busquedaRapida: '', sugerenciasSearch: [] });
    }
  };

  agregarInsumoRapido = async (insumo) => {
    const yaExiste = this.state.todasInsumos.find((i) => i._id === insumo._id);
    if (!yaExiste) {
      await new Promise((resolve) =>
        this.setState(
          (prev) => ({ todasInsumos: [...prev.todasInsumos, insumo] }),
          resolve
        )
      );
    }
    const insumos = this.formRef.current.getFieldValue('insumos') || [];
    const contabilizar = this.formRef.current.getFieldValue('contabilizar');
    const newIdx = insumos.length;
    insumos.push({
      insumoId: insumo._id,
      costo: contabilizar ? (insumo.costo || 0) : 0,
      cantidad: undefined,
    });
    const necesitaLotes = insumo.lotesCaducidades && !this.formRef.current.getFieldValue('conLotesYCaducidades');
    if (necesitaLotes) {
      insumos[newIdx].lotes = [{ numero: '', caducidad: null, cantidad: null }];
    }
    this.formRef.current.setFieldsValue({ insumos });
    setTimeout(() => {
      if (necesitaLotes) {
        const el = document.getElementById(`lote-numero-${newIdx}-0`);
        if (el) el.focus();
        else this.searchRef.current?.focus();
      } else {
        const el = document.querySelector(`#insumo-row-${newIdx} input[placeholder="Cantidad"]`);
        if (el) el.focus();
        else this.searchRef.current?.focus();
      }
    }, 100);
  };

  onSearchInputChange = (valor) => {
    this.setState({ busquedaRapida: valor });
  };

  onSelectSugerencia = (value, option) => {
    if (option?.insumo) {
      this.agregarInsumoRapido(option.insumo);
      this.setState({ busquedaRapida: '', sugerenciasSearch: [] });
      setTimeout(() => this.searchRef.current?.focus(), 80);
    }
  };

  agregarLoteInline = (arrayKey) => {
    const insumos = this.formRef.current.getFieldValue('insumos');
    insumos[arrayKey].lotes = [
      ...(insumos[arrayKey].lotes || []),
      { numero: '', caducidad: null, cantidad: null },
    ];
    this.formRef.current.setFieldsValue({ insumos });
    this.forceUpdate();
  };

  eliminarLoteInline = (arrayKey, loteIdx) => {
    const insumos = this.formRef.current.getFieldValue('insumos');
    insumos[arrayKey].lotes = (insumos[arrayKey].lotes || []).filter((_, i) => i !== loteIdx);
    this.formRef.current.setFieldsValue({ insumos });
    this.forceUpdate();
  };

  updateLoteField = (arrayKey, loteIdx, field, value) => {
    const insumos = this.formRef.current.getFieldValue('insumos');
    if (!insumos[arrayKey].lotes) insumos[arrayKey].lotes = [];
    insumos[arrayKey].lotes[loteIdx] = { ...insumos[arrayKey].lotes[loteIdx], [field]: value };
    const suma = insumos[arrayKey].lotes.reduce((s, l) => s + (Number(l.cantidad) || 0), 0);
    if (suma > 0) insumos[arrayKey].cantidad = suma;
    this.formRef.current.setFieldsValue({ insumos });
    this.forceUpdate();
  };

  render() {

    const isMobile = window.innerWidth <= 1000;

    const conLotesYCaducidades = this.state.conLotesYCaducidades;

    const insumosColumns = conLotesYCaducidades
      ? [
          { title: 'Clave', width: '5%' },
          { title: 'Insumo', width: '25%' },
          { title: 'Unidad', width: '5%' },
          { title: 'Costo', width: '12%' },
          { title: 'Cantidad', width: '12%' },
          ...(this.props.moduloWms ? [{ title: 'Ubicación', width: '10%' }] : []),
          { title: 'Lote', width: '13%' },
          { title: 'Caducidad', width: '13%' },
          { title: 'Acción', width: '15%' },
        ]
      : [
          { title: 'Clave', width: '6%' },
          { title: 'Insumo', width: '38%' },
          { title: 'Unidad', width: '6%' },
          { title: 'Costo', width: '15%' },
          { title: 'Cantidad', width: '15%' },
          ...(this.props.moduloWms ? [{ title: 'Ubicación', width: '12%' }] : []),
          { title: 'Acción', width: '15%' },
        ];

    const allTabs = [
      {
        key: 'insumos',
        label: 'Insumos',
        listName: 'insumos',
        columns: insumosColumns,
        renderHeader: () => (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            width: '100%',
            paddingRight: 8,
          }}>
            <Tooltip
              placement="topLeft"
              title="Modo para capturar insumos con teclado/escáner: escribe la clave o código de barras y presiona Enter para agregar el insumo y abrir el modal de lotes automáticamente"
            >
              <label
                htmlFor="captura-rapida-switch"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 10,
                  background: this.state.capturaModoRapido
                    ? '#a1f9ff2e' 
                    : '#ffffff',
                  border: `1px solid ${this.state.capturaModoRapido ? '#00c1d6' : '#d9e1e7'}`,
                  borderRadius: 999,
                  padding: '4px 14px',
                  height: 32,
                  transition: 'all 0.25s ease',      
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                  cursor: 'pointer',
                  userSelect: 'none',
                }}
              >
                <Typography.Text style={{
                  fontSize: 12.5,
                  color: this.state.capturaModoRapido ?  '#475569' : '#475569',
                  fontWeight: 600,
                  letterSpacing: 0.2,
                  margin: 0,
                  lineHeight: 1,
                }}>
                  Captura rápida
                </Typography.Text>
                <Switch
                  id="captura-rapida-switch"
                  size="small"
                  checked={this.state.capturaModoRapido}
                  onChange={(checked) => this.setState({ capturaModoRapido: checked }, () => {
                    if (checked) setTimeout(() => this.searchRef.current?.focus(), 80);
                  })}
                />
              </label>
            </Tooltip>
            {this.state.capturaModoRapido && (
              <div style={{ flex: 1, minWidth: 0 }}>
                <AutoComplete
                  options={this.state.sugerenciasSearch}
                  onSelect={this.onSelectSugerencia}
                  onChange={this.onSearchInputChange}
                  value={this.state.busquedaRapida}
                  style={{ width: '100%' }}
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ minWidth: 480 }}
                >
                  <Input.Search
                    ref={this.searchRef}
                    prefix={<SearchOutlined style={{ color: '#00BFD6' }} />}
                    placeholder="Escanea o escribe clave/código y presiona Enter  (Ctrl+B)"
                    allowClear
                    enterButton={
                      <Button
                        type="primary"
                        style={{
                          background: 'linear-gradient(135deg, #00BFD6 0%, #28d3ea 100%)',
                          borderColor: '#00BFD6',
                          fontWeight: 600,
                          boxShadow: '0 2px 6px rgba(0, 191, 214, 0.25)',
                        }}
                      >
                        Agregar
                      </Button>
                    }
                    size="middle"
                    onSearch={this.buscarInsumoRapido}
                    className="captura-rapida-search"
                  />
                </AutoComplete>
              </div>
            )}
          </div>
        ),
        renderRow: ({ key, name, restField, arrayKey, remove }) => (
          <FormItem key={key} noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const _row = (getFieldValue('insumos') || [])[arrayKey];
              const _conLotesYCaducidades = getFieldValue('conLotesYCaducidades');
              const _insumo = this.state.todasInsumos?.find(
                (i) => i._id === _row?.insumoId
              );
              const _necesitaLotes = _insumo?.lotesCaducidades;
              const _cantidad = Number(_row?.cantidad) || 0;
              const _lotes = _row?.lotes || [];
              const _sumLotes = _lotes.reduce(
                (s, l) => s + (Number(l.cantidad) || 0),
                0
              );
              // Misma tolerancia que el backend (Components/cantidadLote.js)
              const isRed =
                _necesitaLotes &&
                !_conLotesYCaducidades &&
                _cantidad > 0 &&
                Math.abs(_sumLotes - _cantidad) > 0.0001;
              return (
                <React.Fragment>
             <tr
                id={`insumo-row-${arrayKey}`}
                style={isRed ? { backgroundColor: '#ffccc7' } : {}}
             >
                <td className="td-border">
                  <FormItem noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                      const insumoSeleccionado = this.state.todasInsumos?.find(
                        (insumo) => insumo._id.toString() === insumoId?.toString()
                      );
                      return (
                        <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                          {insumoSeleccionado?.clave || '-'}
                        </div>
                      );
                    }}
                  </FormItem>
                </td>
                <td className="td-border">
                  <FormItem
                    {...restField}
                    name={[name, "insumoId"]}
                    fieldKey={[arrayKey, "insumoId"]}
                    required
                    noStyle
                  >
                    <SelectInsumosItem
                      empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                      headersToken={this.props.headersToken}
                      sinBorde
                      autoFocus
                      ocultarCodigoYUnidad
                      dropdownMatchSelectWidth={600}
                      width="100%"
                      placeholder="Insumo"
                      tiposInsumos="inventariables"
                      onChange={(value, insumo) =>
                        this.onChangeInsumo(
                          value,
                          arrayKey,
                          insumo
                        )
                      }
                    />
                  </FormItem>
                </td>
                <td className="td-border">
                  <FormItem noStyle shouldUpdate>
                    {({ getFieldValue }) => {
                      const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                      const insumoSeleccionado = this.state.todasInsumos?.find(
                        (insumo) => insumo._id.toString() === insumoId?.toString()
                      );
                      return (
                        <div style={{ fontSize: '14px', textAlign: 'center' }}>
                          {insumoSeleccionado?.unidad || '-'}
                        </div>
                      );
                    }}
                  </FormItem>
                </td>
                 <td className="td-border">
                    <FormItem shouldUpdate noStyle>
                      {({ getFieldValue }) => {

                        const contabilizar = getFieldValue('contabilizar')

                        return (
                          <FormItem
                            {...restField}
                            name={[name, "costo"]}
                            fieldKey={[arrayKey, "costo"]}
                            numberCero
                            noStyle
                            required
                            initialValue={0}
                          >
                            <InputNumberItem disabled={!contabilizar} sinBorde />
                          </FormItem>
                        )
                      }}
                    </FormItem>
                  </td>
                  <td className="td-border">
                    <FormItem
                      {...restField}
                      name={[name, "cantidad"]}
                      fieldKey={[arrayKey, "cantidad"]}
                      number
                      noStyle
                      required
                      initialValue={undefined}
                    >
                      <InputNumberItem sinBorde />
                    </FormItem>
                  </td>
                  {this.props.moduloWms && (
                    <td className="td-border">
                      <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => (
                          <FormItem
                            {...restField}
                            name={[name, "ubicacionId"]}
                            fieldKey={[arrayKey, "ubicacionId"]}
                            noStyle
                          >
                            <SelectUbicacionesProyectoItem
                              empresaId={this.props.empresaId}
                              headersToken={this.props.headersToken}
                              proyectoId={getFieldValue('proyectoId')}
                              opciones={this.state.todasUbicaciones.length > 0 ? this.state.todasUbicaciones : undefined}
                              width="100%"
                            />
                          </FormItem>
                        )}
                      </FormItem>
                    </td>
                  )}
                  {this.state.conLotesYCaducidades && (
                    <FormItem
                      noStyle
                      shouldUpdate
                    >
                      {({ getFieldValue }) => {
                        let arrayValue = getFieldValue("insumos");
                        let mostrarLotes = false
                        if (arrayValue[arrayKey]?.insumoId) {
                          const insumo = this.state.todasInsumos.find(
                            (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                          );
                          mostrarLotes = insumo?.lotesCaducidades
                        }
                        if (mostrarLotes) {
                          return (
                            <>
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "lote"]}
                                  fieldKey={[arrayKey, "lote"]}
                                  noStyle
                                  required
                                >
                                  <InputItem placeholder="Lote" />
                                </FormItem>
                              </td>
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "caducidad"]}
                                  fieldKey={[arrayKey, "caducidad"]}
                                  noStyle
                                >
                                  <DatePickerItem placeholder="Caducidad" style={{ width: '100%' }} />
                                </FormItem>
                              </td>
                            </>
                          )
                        } else {
                          return (
                            <td className="td-border" colSpan={2}>
                              No aplica lotes o caducidades
                            </td>
                          )
                        }
                      }}
                    </FormItem>
                  )}
                   <td className="td-border">
                      <FormItem
                        noStyle
                        shouldUpdate
                      >
                            {({ getFieldValue }) => {
                              let arrayValue = getFieldValue("insumos");
                              let conLotesYCaducidades = getFieldValue("conLotesYCaducidades");
                              let mostrarMarbetes = false
                              let mostrarLotes = false
                              let buttons = []
                              let descripcion = ''
                              let mostrarVehiculo = false
                              if (arrayValue[arrayKey]?.insumoId) {
                                const insumo = this.state.todasInsumos.find(
                                  (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                );
                                mostrarMarbetes = insumo?.marbetes
                                mostrarLotes = insumo?.lotesCaducidades
                                descripcion = insumo?.descripcion || ''
                                mostrarVehiculo = insumo?.vehiculo
                              }
                              if (mostrarMarbetes) {
                                buttons.push(
                                  <Tooltip title="Agregar Marbetes" placement="top" overlayInnerStyle={{fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                      type="primary"
                                      size='small'
                                      cyan2
                                      icon={<CommentOutlined />}
                                    onClick={() => {
                                      this.abrirAgregarMarbetes(arrayKey, arrayValue[arrayKey].marbetes)
                                    }}
                                  >
                                    Marbetes
                                  </ButtonItem>
                                  </Tooltip>
                                )
                              }
                              const ocultarBotonLotes = this.state.capturaModoRapido && !this.props.taxidermia
                              if (mostrarLotes && !conLotesYCaducidades && !ocultarBotonLotes) {
                                buttons.push(
                                    <Tooltip title={this.props.taxidermia ? "Animales" : "Lotes"} placement="top" overlayInnerStyle={{fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                    <ButtonItem
                                      type="primary"
                                      size='small'
                                      amarillo2
                                      icon={<ContainerOutlined />}
                                    onClick={() => {
                                      this.abrirAgregarLotes(arrayKey, arrayValue[arrayKey]?.lotes, arrayValue[arrayKey]?.insumoId, descripcion, mostrarVehiculo)
                                    }}
                                  >
                                  </ButtonItem>
                                  </Tooltip>
                                )
                              }

                              return (
                                <div className="acciones-container">
                                   <Space style={{ width: '100%', gap: 5, justifyContent: 'center' }}>
                                    {buttons}
                                    <ButtonItem
                                        key="remove"
                                        rojo2
                                        icon={<DeleteOutlined />}
                                        onClick={() => remove(name)}
                                        size="small"
                                        lessTime
                                      />

                                    </Space>
                                </div>
                              );
                            }}
                      </FormItem>
                    </td>
               </tr>
              {this.state.capturaModoRapido && !this.props.taxidermia && _necesitaLotes && !_conLotesYCaducidades && (
                <tr>
                  <td colSpan={(this.state.conLotesYCaducidades ? 8 : 6)} style={{ padding: '8px 20px 8px 32px', background: '#bbbbbb21', borderBottom: '2px solid #d9d9d9' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #d9d9d9', borderRadius: 4 }}>
                      <thead>
                        <tr style={{ background: '#f0f0f0' }}>
                          <th style={{ textAlign: 'left', padding: '5px 10px', fontSize: 12, width: '30%', borderRight: '1px solid #d9d9d9', borderBottom: '1px solid #d9d9d9' }}>Número *</th>
                          <th style={{ textAlign: 'left', padding: '5px 10px', fontSize: 12, width: '30%', borderRight: '1px solid #d9d9d9', borderBottom: '1px solid #d9d9d9' }}>Caducidad</th>
                          <th style={{ textAlign: 'left', padding: '5px 10px', fontSize: 12, width: '25%', borderRight: '1px solid #d9d9d9', borderBottom: '1px solid #d9d9d9' }}>Cantidad</th>
                          <th style={{ width: '15%', borderBottom: '1px solid #d9d9d9' }}></th>
                        </tr>
                      </thead>
                      <tbody>
                        {_lotes.map((lote, loteIdx) => (
                          <tr key={loteIdx} style={{ borderBottom: '1px solid #e8e8e8' }}>
                            <td style={{ padding: '2px 4px', borderRight: '1px solid #e8e8e8' }}>
                              <InputItem
                                sinBorde
                                id={`lote-numero-${arrayKey}-${loteIdx}`}
                                placeholder="Núm. lote *"
                                value={lote.numero || ''}
                                onChange={(e) => this.updateLoteField(arrayKey, loteIdx, 'numero', e.target.value)}
                                style={{ borderBottom: !lote.numero?.toString().trim() ? '1px solid #ff4d4f' : undefined }}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    e.preventDefault();
                                    document.getElementById(`lote-cantidad-${arrayKey}-${loteIdx}`)?.focus();
                                  }
                                }}
                              />
                            </td>
                            <td style={{ padding: '2px 4px', borderRight: '1px solid #e8e8e8', background: '#fff' }}>
                              <DatePickerItem
                                placeholder="Caducidad"
                                style={{ width: '100%', background: '#fff' }}
                                value={lote.caducidad ? moment(lote.caducidad) : null}
                                onChange={(date) => this.updateLoteField(arrayKey, loteIdx, 'caducidad', date)}
                                format="DD/MM/YYYY"
                              />
                            </td>
                            <td style={{ padding: '2px 4px', borderRight: '1px solid #e8e8e8', background: '#fff' }}>
                              <InputNumberItem
                                sinBorde
                                style={{ background: '#fff' }}
                                id={`lote-cantidad-${arrayKey}-${loteIdx}`}
                                placeholder="Cantidad"
                                value={lote.cantidad}
                                min={0}
                                onChange={(val) => this.updateLoteField(arrayKey, loteIdx, 'cantidad', val)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Tab') {
                                    if (loteIdx === _lotes.length - 1) {
                                      e.preventDefault();
                                      this.agregarLoteInline(arrayKey);
                                      setTimeout(() => {
                                        document.getElementById(`lote-numero-${arrayKey}-${loteIdx + 1}`)?.focus();
                                      }, 50);
                                    }
                                  } else if (e.key === 'Enter') {
                                    e.preventDefault();
                                    this.searchRef.current?.focus();
                                  }
                                }}
                              />
                            </td>
                            <td style={{ padding: '2px 8px', textAlign: 'center' }}>
                              <ButtonItem
                                size="small"
                                lessTime
                                danger
                                onClick={() => this.eliminarLoteInline(arrayKey, loteIdx)}
                              >
                                ✕
                              </ButtonItem>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={4} style={{ padding: '4px 8px', borderTop: '1px solid #d9d9d9' }}>
                            <ButtonItem
                              size="small"
                              lessTime
                              blanco
                              type="dashed"
                              onClick={() => {
                                this.agregarLoteInline(arrayKey);
                                setTimeout(() => {
                                  document.getElementById(`lote-numero-${arrayKey}-${_lotes.length}`)?.focus();
                                }, 50);
                              }}
                              block
                            >
                              + Agregar Lote
                            </ButtonItem>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </td>
                </tr>
              )}
                </React.Fragment>
              );
            }}
          </FormItem>
        ),
        renderFooter: ({ add, fields }) => (
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const proyecto = getFieldValue("proyectoId");
              const contabilizar = getFieldValue("contabilizar");
              const cuentaAbonoId = getFieldValue("cuentaAbonoId");
               return (
                <FormItem noStyle>
                  <div style={{ marginBottom: 6, marginTop: 6 }}>
                    <ButtonItem
                      type="dashed"
                      hotkey="alt+a"
                      cyan
                      block
                      style={{
                          marginTop: 10,
                          marginBottom: 10,
                          justifySelf: fields.length > 0 ? "left" : null,
                          width: fields.length > 0 ? "auto" : null,
                      }}
                      onClick={() => {
                        if (contabilizar) {
                          if (proyecto && cuentaAbonoId) {
                            add()
                          } else {
                            message.info('Agregue los datos primero')
                          }
                        } else {
                          if (proyecto) {
                            add()
                          } else {
                            message.info('Agregue los datos primero')
                          }
                        }
                      }}
                      icon={<PlusOutlined />}
                    >
                      Agregar Campo
                      </ButtonItem>
                    </div>
                  </FormItem>
                );
            }}
          </FormItem>
        ),
    },
  ];
                  

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Orden - Agregar Inventario"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <ButtonItem
              type="primary"
              key="descargarExcel"
              icon={<FileExcelOutlined />}
              onClick={this.descargarExcelCI.bind(this)}
              verde
            >
              Plantilla
            </ButtonItem>,
            this.state.archivoError ? <ButtonItem onClick={this.descargarArchivoErrores.bind(this)} danger>Descargar Errores</ButtonItem> : null,
            <Upload
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: false,
              }}
              fileList={this.state.archivosExcel}
              customRequest={this.onChangeArchivo.bind(this)}
              accept='.xlsx'
            >
              <ButtonItem icon={<UploadOutlined />}>Subir Excel</ButtonItem>
            </Upload>,
          ]}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarInventario"
              layout
              bottom={
                  <div className="general-form-action-buttons">
                    <ButtonItem
                      type="primary"
                      htmlType="submit"
                      hotkey="shift+a"
                      cyanB
                    >
                      Agregar
                    </ButtonItem>
                  </div>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >   
            
              <FormItem
                noStyle
                shouldUpdate={(prev, curr) =>
                  prev.insumos?.length !== curr.insumos?.length
                }
              >

                {({ getFieldValue }) => {
                  const insumos = getFieldValue("insumos");
                  const disabled = insumos && insumos.length > 0 ? true : false;
                  return (
                    <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
                      <Col xs={24} xl={24}>
                        <DynamicCardForm
                          title="DATOS GENERALES"
                          style={{ margin: 0, height: '100%' }}
                        >
                          <Row>
                            <Col span={12}>
                              <FormItem label="Proyecto" name="proyectoId" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}>
                                <SelectItem
                                  disabled={disabled}
                                  placeholder="Proyecto"
                                  onChange={(value) => this.cargarUbicacionesDelAlmacen(value)}
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            </Col>
                            <Col span={12}>
                              <FormItem
                                name="referencia"
                                label="Referencia"
                                margin
                                pattern
                                labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}
                              >
                                <InputItem placeholder="Referencia" />
                              </FormItem>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12}>
                              <FormItem
                                label="Contabilizar"
                                name="contabilizar"
                                margin
                                initialValue={true}
                                valuePropName="checked"
                                labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}
                              >
                                <SwitchItem disabled={disabled || !this.props.permisoContabilizarAgregarInventario} />
                              </FormItem>
                            </Col>
                            <Col span={12}>
                              <FormItem noStyle shouldUpdate>
                                {({ getFieldValue }) => {
                                  const contabilizar = getFieldValue('contabilizar')
                                  if (contabilizar) {
                                    return (
                                      <FormItem label="Cuenta Abono" margin labelCol={{ span: 6 }} wrapperCol={{ span: 15 }}>
                                        <Input.Group compact>
                                          <FormItem name="cuentaAbonoId" required noStyle>
                                            <SelectItem disabled={disabled} placeholder="Cuenta Abono" width="80%">
                                              {this.state.objetoCuentaContable}
                                            </SelectItem>
                                          </FormItem>
                                          <ButtonItem
                                            icon={<PlusOutlined />}
                                            style={{ width: "12%", marginLeft: 5 }}
                                            disabled={disabled}
                                            onClick={this.abrirAgregarCuentaContable.bind(this)}
                                          />
                                        </Input.Group>
                                      </FormItem>
                                    )
                                  }
                                }}
                              </FormItem>
                            </Col>
                          </Row>
                          {this.props.lotesCaducidades && (
                            <Row>
                              <Col span={12}>
                                <FormItem
                                  label="Lotes"
                                  name="conLotesYCaducidades"
                                  margin
                                  valuePropName="checked"
                                  tooltip="Si los insumos que agregaras tienen lotes o caducidades, activa esta opción para poder agregarlos por fila"
                                  labelCol={{ span: 6 }} wrapperCol={{ span: 14 }}
                                >
                                  <SwitchItem onChange={(e) => this.setState({ conLotesYCaducidades: e })} />
                                </FormItem>
                              </Col>
                            </Row>
                          )}
                        </DynamicCardForm>
                      </Col>
                    </Row>
                  )
                }}
              </FormItem>
               <div style={{ marginTop: 20 }}>
                  <TabbedDynamicTable
                    formInstance={this.formRef}
                    defaultActiveKey="insumos"
                    isMobile={isMobile}
                    tabs={allTabs}
                  />
              </div>
            </Form>
          </Spin>
        </div>
        <AgregarCuentaContable
          visible={this.state.modalAgregarCuentaContable}
          cerrarAgregarCuentaContable={this.cerrarAgregarCuentaContable.bind(this)}
        />
        <AgregarMarbetes
          visible={this.state.modalAgregarMarbetes}
          cerrarAgregarMarbetes={this.cerrarAgregarMarbetes.bind(this)}
          marbetes={this.state.modalAgregarMarbetesMarbetes}
        />
        <AgregarLotes
          visible={this.state.modalAgregarLotes}
          cerrarAgregarLotes={this.cerrarAgregarLotes.bind(this)}
          lotes={this.state.modalAgregarLotesLotes}
          insumoId={this.state.modalAgregarLotesInsumoId}
          fechaIngresoM={this.state.modalAgregarLotesFechaIngresoM}
          tipoEspecie={this.state.modalAgregarLotesTipoEspecie}
          vehiculo={this.state.modalAgregarLotesVehiculo}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    lotesCaducidades: state.empresa.lotesCaducidades,
    moduloWms: state.empresa.moduloWms,
    permisoContabilizarAgregarInventario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6526099a3d4cd64267a901dd"
      )?.activado,
  };
};

export default connect(mapStateToProps)(AgregarInventario);